export default function Brokerinfo({ formData} ) {
  return (
      <div className="bminfo">
        <div className="phone">
          <p>ԱՆՁՆ․ ՀԱՄԱՐ</p>
          <span>{formData.ownPhoneNumber}</span>
        </div>
        <div className="phone">
          <p>ԱՇԽ․ ՀԱՄԱՐ</p>
          <span>{formData.workPhoneNumber}</span>
        </div>
      </div>
  );
}
